import { render } from "./square_banner.vue?vue&type=template&id=06d61640&scoped=true"
import script from "./square_banner.vue?vue&type=script&lang=js"
export * from "./square_banner.vue?vue&type=script&lang=js"

import "./square_banner.vue?vue&type=style&index=0&id=06d61640&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d61640"]])

export default __exports__